import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'css-loader',
    templateUrl: './loader.component.html'
})
export class CSSLoaderComponent implements OnInit {
    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./src/ts/Apps/CaseLookup/src/app/loader/loader.component.ts